import React from 'react'

import './Hero.scss'

export default class Hero extends React.Component {
  render () {
    const { imageSource, className, fullWidth, srcSet, alt } = this.props

    return (
      <div className='container-fluid'>
        <div className='row Hero__wrapper'>
          <div
            className={`Hero ${fullWidth ? 'Hero--full' : ''} ${className ||
							''}`}
          >
            {imageSource && (
              <div className={`Hero__image-container ${''}`}>
                <img
                  className='Hero__image'
                  src={imageSource}
                  srcSet={srcSet}
                  alt={alt}
                />
              </div>
            )}
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Hero/index.js